<template>
  <div class="pos-relative ms-tagbox-control">
    <div
      v-if="isShowIconControl && iconControlName"
      :class="iconControlName"
    />
    <DxTagBox
      :ref="controlRef"
      class="ms-select-box"
      :style="[
        {
          width: isNaN(width) ? width : width + 'px',
          'padding-left': isShowIconControl && iconControlName ? '28px' : '',
        },
      ]"
      :class="{ isValid: errorProvider.isValid }"
      :element-attr="{ id: 'elementId', class: 'class-name' }"
      :value="listData"
      :data-source="dataSourceX"
      :disabled="disabled"
      :display-expr="displayExpr"
      :value-expr="valueExpr"
      :search-expr="searchExpr"
      :search-enabled="true"
      no-data-text="Không có dữ liệu"
      :placeholder="placeholder"
      :show-selection-controls="true"
      tag-template="tagTemplate"
      item-template="item"
      @key-up="onKeyUp"
      @onOpened="onOpened"
      @itemClick="itemClick"
    >
      <template #tagTemplate="{ data }">
        <div class="selected-item">
          <div class="item-text m-r-8">
            {{ data[displayExpr] }}
          </div>
          <div
            class="item-icon icon-multiple cursor-pointer"
            @click="removeItem(data)"
          />
        </div>
      </template>
      <!-- dvquang2 thêm custom template -->
      <template #item="{ data }">
        <slot
          name="item-template"
          :data="data"
        >
          {{ data[displayExpr] }}
        </slot>
      </template>
    </DxTagBox>
    <p
      v-if="errorProvider.isValid"
      :class="{ 'text-error': errorProvider.isValid }"
    >
      {{ errorProvider.message }}
    </p>
  </div>
</template>
<script>
import DxTagBox from "devextreme-vue/tag-box";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import msBaseComponent from "@/components/controls/msbase/msBaseComponent.vue";
import { MsControlRef } from "@/models/enums/MsControlRefConst.js";

export default {
  name: "MsTagbox",
  components: {
    DxTagBox,
  },
  extends: msBaseComponent,
  props: {
    //Giá trị truyền xuống
    value: {
      type: Array,
      default: () => [],
    },
    //Danh sách dữ liệu đổ vào
    dataSource: {
      type: Array,
      default: () => [],
    },
    //Tên khởi tạo ban đầu nếu có
    initItem: {
      type: [Array],
      default: null,
    },
    //Chiều dài của control
    width: {
      type: [String, Number],
      default: "100%",
    },
    //Trường xét giá trị
    valueExpr: {
      type: String,
      default: null,
    },
    //Trường hiển thị text
    displayExpr: {
      type: String,
      default: null,
    },
    //Các trường cần tìm kiếm
    searchExpr: {
      type: [Array, String],
      default: () => [],
    },
    //placeholder
    placeholder: {
      type: String,
      default: "",
    },
    //Thêm điều kiện lọc
    filter: {
      type: String,
      default: null,
    },
    // //Danh sách khởi tạo ban đầu dạng danh sách
    // listInitItem: {
    //   Type: Array,
    //   default: [],
    // },
    //Có gọi paging hay đổ dữ liệu bình thường
    isPaging: {
      type: [String, Boolean],
      default: true,
    },
    //Hàm paging
    functionPaging: {
      type: Function,
      default: () => {}
    },
    //Hàm xử lý thêm sau khi gọi paging
    afterGetPaging: {
      type: Function,
      default: null,
    },
    // custom validate
    paramValidate:{
      type: Object,
      default: () => {}
    },
    // có hienr thị icon không
    isShowIconControl: {
      type: Boolean,
      default: false,
    },
    // tên icon được sử dụng (chỉ được icon max-width < 24px)
    iconControlName: {
      type: String,
      default: "",
    },
    // có disabled không
    disabled: {
      type: Boolean,
      default: false,
    },
    isPagingSource: {
        type: Boolean,
        default: true,
    }
  },
  data() {
    return {
      isLoadData: true,
      listDataSource: [],
      listData: [],
      controlRef: MsControlRef.MsTagBox,
      listInitItem: [],
      valueData: this.value,
      dataSourceX: []
    };
  },
  watch: {
    listInitItem: {
      handler(val) {
        this.listData = val;
      },
      immediate: true,
    },
    value: {
      handler(newVal, oldVal) {
        if (this.rules.includes("required")) {
          // if (newVal && this.listData.length > 0) {
          //   this.errorProvider.isValid = false;
          // } else if (this.listData.length == 0) {
          //   this.errorProvider.isValid = true;
          //   this.errorProvider.message = this.$t("i18nCommon.ValidateEmplty");
          // }
          this.validate();
        }
      },
    },

    dataSource: {
      immediate: true,
      handler(newVal, oldVal) {
        if (!this.isPaging) {
          this.dataSourceX = newVal;
        }
      },
    }
  },
  created() {
    if (this.isLoadData && this.isPaging) {
      this.loadDataPaging();
      this.isLoadData = false;
      
      if (this.dataSourceX._items.length == 0 && this.value && this.initItem) {
        for (var i = 0; i < this.value.length; i++) { 
          var newEmp = {};
          newEmp[this.valueExpr] = this.value[i];
          newEmp[this.displayExpr] = this.initItem[i];
          this.listInitItem.push(newEmp);
        }
      }
    } else {
      let listValueItem = [];
      if (this.value && this.dataSourceX && this.dataSourceX.length > 0) {
        for (var i = 0; i < this.value.length; i++) {
          const newEmp = this.dataSourceX.find(
            (x) => x[this.valueExpr] == this.value[i]
          );
          listValueItem.push(newEmp);
        }
      }
      this.listInitItem = listValueItem;
    }
  },
  methods: {
    /**
     * Hàm xảy ra khi mở combo
     * Created by cvcuong1 - 7/5/2021
     */
    onOpened(e) {
      // if (this.isLoadData && this.isPaging) {
      //   this.loadDataPaging();
      //   this.isLoadData = false;
      // }
    },
    /**
     * Hàm tạo dữ liệu dạng get paging
     * created by cvcuong1 - 7/5/2021
     */
    loadDataPaging() {
      const me = this;
      
      me.dataSourceX = new DataSource({
        store: new CustomStore({
          load: async (loadOptions) => { 
            const params = {
              PageSize: loadOptions.take || 15,
              PageIndex:
                Math.ceil(loadOptions.skip / loadOptions.take) + 1 || 1,
            };

            if (!me.isPagingSource && params.PageIndex > 1) {
              return;
            }

            let where = [];
            if (loadOptions.searchValue) {
              let value = encodeURI(loadOptions.searchValue);
              where.push([me.searchExpr, "contains", value]);
            }

            let ignorData = me.listData;
            // bỏ qua các giá trị được chọn trước đó
            if (ignorData.length > 0) {
              const valueWhere = [];
              for (let i = 0; i < ignorData.length; i++) {
                if (ignorData[i] && ignorData[i][me.valueExpr]) {
                  const list = [];
                  list.push(me.valueExpr, "<>", ignorData[i][me.valueExpr]);
                  valueWhere.push(list);
                }
                if (i < ignorData.length - 1) {
                  valueWhere.push("And");
                }
              }
              if (valueWhere.length > 0) {
                if (where.length > 0) {
                  where.push("And");
                  where.push(valueWhere);
                } else {
                  where = valueWhere;
                }
              }
            }
            if (where.length) {
              params.Filter = btoa(JSON.stringify(where));
            }

            // if (me.filter) {
            //   params["Filter"] = me.filter;
            // }

            return new Promise((resolve, reject) => {
              me.functionPaging(params)
                .then(function (result) {

                  if (result.data && result.data.Success) {
                    // Fix cho những trường hợp dữ liệu trả về không có PageData
                    if (!result.data.Data.PageData && result.data.Data && result.data.Data.length) {
                      result.data.Data.PageData = result.data.Data;
                    }

                    if (result.data.Data.PageData) {
                      result.data.Data.PageData.forEach((item) => {
                        if (
                          me.listDataSource.findIndex(
                            (x) => x[me.valueExpr] == item[me.valueExpr]
                          ) == -1
                        ) {
                          me.listDataSource.push(item);
                        }
                      });
                    }

                    for (var i = 0; i < me.listInitItem.length; i++) {
                      if (result.data.Data.PageData) {
                        if (
                          result.data.Data.PageData.findIndex(
                            (x) =>
                              x[me.valueExpr] ==
                              me.listInitItem[i][me.valueExpr]
                          ) != -1
                        ) {
                          // var valueCurren = me.valueData;
                          // me.valueData = [];
                          // setTimeout(() => {
                          //   me.valueData = valueCurren;
                          // }, 0);
                        } else if (
                          me.listDataSource.findIndex(
                            (x) =>
                              x[me.valueExpr] ==
                              me.listInitItem[i][me.valueExpr]
                          ) == -1
                        ) {
                          result.data.Data.PageData.push(me.listInitItem[i]);
                          me.listDataSource.push(me.listInitItem[i]);
                        }
                      }
                    }
                    if (me.afterGetPaging) {
                      me.afterGetPaging(result.data.Data.PageData);
                    }
                    
                    resolve(result.data.Data.PageData);
                  }
                })
                .catch((err) => reject(err));
            });
          },
          // byKey: function (key) {
          //   return { id: key[me.valueExpr] };
          // },
          loadMode: "processed",
        }),
        pageSize: 15,
      });
    },
    /**
     * Hàm chọn item
     * Created by cvcuong1 - 7/5/2021
     */
    itemClick(e) {
      if (
        this.valueData &&
        this.valueData.findIndex((x) => x == e.itemData[this.valueExpr]) == -1
      ) {
        if (!this.valueData) {
          this.valueData = [];
        }
        this.valueData.push(e.itemData[this.valueExpr]);
        this.listData.push(e.itemData);
        this.$emit("selected", e.itemData);
        this.$emit("listData", this.listData);
      } else {
        this.valueData = this.valueData.filter((x) => x != e.itemData[this.valueExpr]);
        this.listData = this.listData.filter(
          (x) => x[this.valueExpr] != e.itemData[this.valueExpr]
        );
        this.$emit("remove", e.itemData);
        this.$emit("listData", this.listData);
      }
    },

    /**
     * xử lý sự kiện bấm nút backspace
     * nhviet 2021.09.01
     */
    onKeyUp(e) {
      // if (e.event.keyCode == 8) {
      //   // if(this.)
      //   if (this.listData && this.listData.length > 0) {
      //     this.removeItem(this.listData[this.listData.length - 1]);
      //   }
      // }
    },
    /**
     * Hàm xóa item bằng nút X
     * Created by cvcuong1 - 16/8/2021
     */
    removeItem(item) {
      this.valueData = this.valueData.filter((x) => x != item[this.valueExpr]);
      this.listData = this.listData.filter(
        (x) => x[this.valueExpr] != item[this.valueExpr]
      );
      this.$emit("remove", item);
      this.$emit("listData", this.listData);
    },

    // override lại hàm validate base
    // nhviet
    validateRequired(valueData) {
      if (this.listData && this.listData.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/controls/var-color.scss";
@import "@/assets/scss/controls/_variables.scss";
.ms-tagbox-control {
  .icon-job-position {
    position: absolute;
    z-index: 1;
    top: 6px;
    left: 8px;
  }
  .dx-texteditor-input {
    padding-left: 0px;
  }
}
.dx-selectbox-popup-wrapper {
  .dx-overlay-content {
    border: none !important;
    padding: 0px;
    min-height: 80px;
  }
  .dx-scrollbar-vertical.dx-scrollbar-hoverable {
    margin-right: -10px;
  }
  .dx-list-item.dx-state-focused {
    background-color: var(--primary-bg) !important;
    color: var(--text-primary-color) !important;
  }
  .dx-list-item.dx-list-item-selected {
    background-color: var(--primary-bg) !important;
    color: var(--primary) !important;
  }
  .dx-list-item.dx-state-active {
    background-color: var(--primary-bg) !important;
    color: var(--primary) !important;
  }
  .dx-list-item {
    border-radius: 4px;
  }
  .dx-popup-content {
    padding: 8px;
  }
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .item-select-box {
    display: flex !important;
    padding: 8px !important;
  }
  .dx-empty-message {
    font-style: italic;
    font-weight: 500;
    color: var(--text-secondary-color);
  }
}
.ms-select-box.dx-state-focused {
  border: 1px solid var(--primary) !important;
}
.ms-select-box.dx-state-hover {
  border: 1px solid var(--primary) !important;
}
.ms-select-box {
  border-radius: 4px;
  border: solid 1px #ddd;
  .dx-dropdowneditor-icon {
    background-color: #ffffff !important;
    border: none !important;
  }
  .dx-tag {
    max-width: calc(100% - 5px);
    margin-right: 4px;
    .selected-item {
      color: var(--text-primary-color);
      display: flex;
      align-items: center;
      border-radius: 4px;
      background-color: #e8eaef;
      padding-left: 8px;
      padding-right: 4px;
      margin: 2px 0;
      border: none;
      height: 28px;
      width: 100%;
      .item-text {
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .dx-tag-container.dx-texteditor-input-container {
    padding: 2px 8px 2px 8px !important;
    width: 100%;
    overflow-y: auto;
    max-height: 100px;
  }
  .icon-multiple {
    transform: scale(0.5);
    width: 20px !important;
    min-width: 20px;
  }
}
.dx-list-select-all {
  display: none;
}
.dx-list-select-checkbox-container {
  display: none;
}

.isValid {
  border: 1px solid $input-error-border-color !important;
}

.dx-state-hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>